/**
 * 共通カラー定数
 * アプリケーション全体で使用する色の定義
 */

/**
 * ベースカラー
 */
export const BASE_COLORS = {
  /** 白色 */
  WHITE: '#fff',
  /** 黒色 */
  BLACK: '#000',
  /** グレー */
  GRAY: '#8c8c8c',
  /** ライトグレー */
  LIGHT_GRAY: '#f0f0f0',
} as const;

/**
 * テーマカラー（Ant Design準拠）
 */
export const THEME_COLORS = {
  /** プライマリカラー（青） */
  PRIMARY: '#1890ff',
  /** 成功（緑） */
  SUCCESS: '#52c41a',
  /** 警告（オレンジ） */
  WARNING: '#faad14',
  /** エラー（赤） */
  ERROR: '#ff4d4f',
  /** 情報（青） */
  INFO: '#1890ff',
  /** 強調エラー（濃い赤） */
  DANGER: '#f5222d',
} as const;

/**
 * ダークテーマカラー
 */
export const DARK_THEME = {
  /** サイドバー・メニュー背景色 */
  BACKGROUND: '#001529',
  /** ダークテーマのボーダー色 */
  BORDER: '#002140',
  /** ダークテーマのテキスト色 */
  TEXT: '#fff',
} as const;

/**
 * Consoleテーマカラー（パープル系）
 */
export const CONSOLE_THEME = {
  /** サイドバー・メニュー背景色（パープル） */
  BACKGROUND: '#2a0845',
  /** Consoleテーマのボーダー色（濃いパープル） */
  BORDER: '#3d1259',
  /** Consoleテーマのテキスト色 */
  TEXT: '#fff',
  /** Consoleテーマのアクセントカラー（明るいパープル） */
  ACCENT: '#722ed1',
  /** Consoleテーマのライトアクセントカラー */
  ACCENT_LIGHT: '#9254de',
} as const;

/**
 * ステータスカラー
 */
export const STATUS_COLORS = {
  /** 稼働中・正常 */
  ACTIVE: '#52c41a',
  /** 停止中 */
  STOPPED: '#8c8c8c',
  /** 警告 */
  WARNING: '#faad14',
  /** エラー */
  ERROR: '#ff4d4f',
  /** 正常 */
  NORMAL: '#52c41a',
} as const;

/**
 * 型定義
 */
export type BaseColor = typeof BASE_COLORS[keyof typeof BASE_COLORS];
export type ThemeColor = typeof THEME_COLORS[keyof typeof THEME_COLORS];
export type DarkThemeColor = typeof DARK_THEME[keyof typeof DARK_THEME];
export type StatusColor = typeof STATUS_COLORS[keyof typeof STATUS_COLORS];